import React, { Fragment, useMemo, useState } from "react";
import { Sidebar } from "./Sidebar";
import { PageSelectUnit } from "./PageSelectUnit";
import { PageSelectService } from "./PageSelectService";
import { PageSelectDate } from "./PageSelectDate";
import { PageSelectTime } from "./PageSelectTime";
import { Helmet } from "react-helmet";
import useAppForm from "hooks/useAppForm";
import { PageInfo } from "./PageInfo";

export interface FormValueProps {
    specialtyId?: number;
    userId?: number;
    method?: string;
    date?: string;
    timeFrameId?: number;

    fullName?: string;
    email?: string;
    description?: string;
}
export const PageViewBooking = () => {
    const form = useAppForm<FormValueProps>({ method: "Lấy vé tại quầy" }, {
        fullName: { required: "Vui lòng nhập họ và tên" },
        email: { required: "Vui lòng nhập số điện thoại" },
    });

    const step = useMemo(() => {
        if (!form.values.specialtyId) {
            return 0;
        }
        if (!form.values.userId) {
            return 1;
        }
        if (!form.values.date) {
            return 2;
        }
        if (!form.values.timeFrameId) {
            return 3;
        }
        if (!form.values.fullName || !form.values.email) {
            return 4;
        }
        return 4;
    }, [form.values])
    return (
        <Fragment>
            <Helmet>
                <title>Đặt hẹn | Bệnh viện</title>
                <meta name="description" content="Thông tin liên hệ với chúng tôi" />
            </Helmet>
            <section className="py-10 bg-gray-50">
                <div className="container mx-auto px-4">

                    <div className="flex flex-col md:flex-row p-4 md:p-6 space-y-6 md:space-y-0 md:space-x-6 bg-gray-50">
                        <Sidebar form={form} />
                        <div className="w-full md:w-3/4">
                            {step === 0 && <PageSelectUnit form={form} />}
                            {step === 1 && <PageSelectService form={form} />}
                            {(step === 2 || step === 3) && <PageSelectDate form={form} />}
                            {step === 3 && <PageSelectTime form={form} />}
                            {step === 4 && <PageInfo form={form} />}
                        </div>
                    </div>

                </div>
            </section>
        </Fragment>
    );
}


export default PageViewBooking;

export { default as PageViewBookingAlert } from "./Notification";